import store from '@/store'
const base = (process.env.VUE_APP_API_BASE_URL || '').replace(/\/$/, '') + '/oa/admin/chat-audit'
export async function auditRequest(path, params = {}, binary = false) {
  const controller = new AbortController(), timer = setTimeout(() => controller.abort(), binary ? 120000 : 30000)
  try {
    const query = new URLSearchParams(Object.entries(params).filter(([,v]) => v !== undefined && v !== null)).toString()
    const r = await fetch(base + path + (query ? '?' + query : ''), {headers:{Authorization:'Bearer '+store.state.token,'Win-Type':'3'},cache:'no-store',signal:controller.signal})
    if (binary && r.ok && !(r.headers.get('content-type') || '').includes('json')) return await r.blob()
    const body = await r.json().catch(() => ({}))
    if (!r.ok || body.code !== 0) { const e = new Error(body.message || '聊天记录读取失败'); e.denied = r.status === 401 || r.status === 403 || body.code === 401 || body.code === 403; throw e }
    return body.data
  } catch (e) { if(e.name === 'AbortError') throw new Error('请求超时，请重试'); throw e } finally {clearTimeout(timer)}
}

export const messageType = type => ({TEXT:'文字',IMAGE:'图片',VIDEO:'视频',VOICE:'语音',FILE:'文件',TODO:'待办',SCHEDULE:'日程',DING:'钉一下'}[type] || type)
export function mergeMessages(oldRows, incoming, older = false, limit = 500) {
  const rows = Array.from(new Map([...oldRows,...incoming].map(x => [String(x.id),x])).values()).sort((a,b) => Number(a.id)-Number(b.id))
  return older ? rows.slice(0,limit) : rows.slice(-limit)
}
